<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">日報検索</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <button
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-download mr-1"></span>Excel出力
        </button>
      </div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>対象</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-target">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <!--------------------  -------------------->
              <div class="row">
                <div class="col-md-1 contTitle">記載者</div>
                <div class="col-md-5 contCnt selectedClear">
                  <vSelect multiple :options="optionsOp"></vSelect>
                </div>
                <div class="col-md-1 contTitle">対象期間</div>
                <div class="col-md-5 contCnt input-daterange input-group">
                  <div class="input-daterange input-group" id="datepicker-5">
                    <input type="date" class="form-control" name="start" />
                    <div class="input-group-append input-group-prepend">
                      <span class="input-group-text fs-xl" style="height: 35px"
                        >－</span
                      >
                    </div>
                    <input type="date" class="form-control" name="end" />
                  </div>
                </div>
              </div>
              <!--------------------  -------------------->
              <div class="row">
                <div class="col-md-1 contTitle">種別</div>
                <div class="col-md-5 contCnt">
                  <vSelect :options="opReportStatus"></vSelect>
                </div>
              </div>
              <!--------------------  -------------------->
              <div class="row">
                <button
                  type="button"
                  class="btn btn-primary waves-effect waves-themed btn-search mx-auto"
                  :disabled="btnDisable"
                >
                  検索
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--------------------  -------------------->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>日報一覧</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-list">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <div class="row">
                <div class="col-auto ml-auto">
                  <button
                    type="button"
                    class="btn btn-sm btn-primary waves-effect waves-themed mr-1"
                    :disabled="btnDisable"
                  >
                    日付順
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-primary waves-effect waves-themed mr-1"
                    :disabled="btnDisable"
                  >
                    担当者順
                  </button>
                </div>
              </div>
              <!-- good table start -->
              <vue-good-table :columns="columns" :rows="rows">
                <template #table-row="props">
                  <div
                    v-if="props.column.field == 'btnDet'"
                    class="gtablecell btnDetCell"
                  >
                    <a
                      v-bind:href="
                        '/jyutyuinput?record_id=' + props.row.c_project_number
                      "
                    >
                      <button
                        type="button"
                        class="btn btn-xs btn-primary waves-effect waves-themed"
                      >
                        詳細
                      </button>
                    </a>
                  </div>
                </template>
              </vue-good-table>
              <!-- good table end -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- エラー確認モーダル -->
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-good-table-next/dist/vue-good-table-next.css";
import { VueGoodTable } from "vue-good-table-next";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";

@Options({
  components: {
    vSelect,
    VueGoodTable,
    Mo_modal_alert,
  },
})
export default class DailyReportSearch extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  btnDisable = false;

  optionsOp = [
    { label: "社員１", code: 1 },
    { label: "社員２", code: 2 },
    { label: "社員３", code: 3 },
    { label: "社員４", code: 4 },
  ];
  opReportStatus = [
    { label: "決定", code: 1 },
    { label: "提案", code: 2 },
    { label: "調査", code: 3 },
  ];
  columns = [
    {
      label: "詳細",
      field: "btnDet",
      thClass: "text-center",
      tdClass: "text-center",
      width: "10%",
    },
    {
      label: "種別",
      field: "report_status",
      thClass: "text-center",
    },
    {
      label: "記載者",
      field: "staff_nm",
      thClass: "text-center",
    },
    {
      label: "日付",
      field: "report_day",
      thClass: "text-center",
    },
    {
      label: "案件名",
      field: "project_nm",
      thClass: "text-center",
    },
    {
      label: "商談先",
      field: "report_prospect",
      thClass: "text-center",
    },
    {
      label: "場所",
      field: "report_place",
      thClass: "text-center",
    },
    {
      label: "内容",
      field: "report_content",
      thClass: "text-center",
    },
    {
      label: "売上",
      field: "report_claim_sales",
      thClass: "text-center",
      tdClass: "text-right",
    },
    {
      label: "仕入",
      field: "report_claim_supplier",
      thClass: "text-center",
      tdClass: "text-right",
    },
  ];
  rows = [
    {
      id: 1,
      report_status: "提案",
      staff_nm: "中前 忠久",
      report_day: "2020-10-02",
      project_nm: "サイエンス",
      report_prospect: "プレジール",
      report_place: "豊中市庄本",
      report_content: "広告物申請書引取",
      report_claim_sales: "150,000",
      report_claim_supplier: "80,000",
    },
    {
      id: 2,
      report_status: "提案",
      staff_nm: "中前 忠久",
      report_day: "2020-10-02",
      project_nm: "サイエンス",
      report_prospect: "プレジール",
      report_place: "豊中市庄本",
      report_content: "広告物申請書引取",
      report_claim_sales: "150,000",
      report_claim_supplier: "80,000",
    },
    {
      id: 3,
      report_status: "提案",
      staff_nm: "中前 忠久",
      report_day: "2020-10-02",
      project_nm: "サイエンス",
      report_prospect: "プレジール",
      report_place: "豊中市庄本",
      report_content: "広告物申請書引取",
      report_claim_sales: "150,000",
      report_claim_supplier: "80,000",
    },
  ];
}
</script>
